export const allComics = [
  {
    id: 1,
    title: "我的野蛮王妃",
    author: "朴秀珍",
    category: "恋爱",
    categorySlug: "romance",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20beautiful%20girl%20and%20prince%20in%20palace%20setting%2C%20soft%20pastel%20colors%2C%20elegant%20illustration%20style%2C%20clean%20white%20background%20with%20subtle%20floral%20elements%2C%20romantic%20atmosphere%2C%20delicate%20lineart%2C%20professional%20manga%20style%20cover&width=800&height=1120&seq=comic-cover-01&orientation=portrait",
    rating: 9.7,
    views: "1280万",
    status: "连载中",
    latestChapter: "第203话",
    updateDate: "2026-07-07",
    description: "普通女高中生意外成为王室王妃，与冷酷王子的浪漫爱情故事就此展开。宫廷斗争与甜蜜恋爱交织，带你体验不一样的王室罗曼史。平凡女孩踏上不平凡的旅程，在华丽宫殿中寻找属于自己的幸福。",
    tags: ["恋爱", "宫廷", "校园"],
    chapters: [
      { num: 203, title: "幸福的开始", date: "2026-07-07" },
      { num: 202, title: "最后的考验", date: "2026-07-06" },
      { num: 201, title: "王室的秘密", date: "2026-07-05" },
      { num: 200, title: "200话特辑", date: "2026-07-04" },
      { num: 199, title: "命运的转折", date: "2026-07-03" },
      { num: 198, title: "深夜的告白", date: "2026-07-02" },
      { num: 197, title: "误会解除", date: "2026-07-01" },
      { num: 196, title: "危机降临", date: "2026-06-30" }
    ]
  },
  {
    id: 2,
    title: "剑与魔法学院",
    author: "金贤宇",
    category: "奇幻",
    categorySlug: "fantasy",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20young%20swordsman%20with%20magical%20aura%20in%20academy%20setting%2C%20dynamic%20action%20pose%2C%20warm%20golden%20and%20crimson%20color%20scheme%2C%20clean%20white%20background%2C%20epic%20fantasy%20illustration%20style%2C%20professional%20anime%20cover%20art&width=800&height=1120&seq=comic-cover-02&orientation=portrait",
    rating: 9.5,
    views: "980万",
    status: "连载中",
    latestChapter: "第187话",
    updateDate: "2026-07-06",
    description: "在魔法与剑术并存的世界顶级学院中，少年凭借天赋与努力一步步登上巅峰。热血战斗、真挚友情、奇幻冒险，应有尽有！学院中的每场比试都扣人心弦，每位同伴都值得信赖。",
    tags: ["奇幻", "热血", "校园"],
    chapters: [
      { num: 187, title: "终局之战", date: "2026-07-06" },
      { num: 186, title: "觉醒的力量", date: "2026-07-05" },
      { num: 185, title: "宿命对决", date: "2026-07-04" }
    ]
  },
  {
    id: 3,
    title: "社长大人请自重",
    author: "李恩智",
    category: "恋爱",
    categorySlug: "romance",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20office%20romance%20manhwa%20cover%2C%20handsome%20CEO%20man%20and%20beautiful%20employee%20woman%2C%20modern%20office%20setting%2C%20elegant%20and%20mature%20style%2C%20soft%20rose%20and%20cream%20color%20palette%2C%20clean%20minimal%20background%2C%20professional%20romance%20cover%20illustration&width=800&height=1120&seq=comic-cover-03&orientation=portrait",
    rating: 9.6,
    views: "1560万",
    status: "连载中",
    latestChapter: "第215话",
    updateDate: "2026-07-07",
    description: "职场新人遇上帅气社长，从误会到相知相爱。办公室里的甜蜜恋情，让人心跳加速的浪漫职场故事！谁说办公室恋情不能开花结果？看平凡员工如何俘获社长的心。",
    tags: ["恋爱", "职场", "都市"],
    chapters: [
      { num: 215, title: "新的开始", date: "2026-07-07" },
      { num: 214, title: "真心话", date: "2026-07-06" },
      { num: 213, title: "社长的选择", date: "2026-07-05" }
    ]
  },
  {
    id: 4,
    title: "恶魔的契约",
    author: "崔允儿",
    category: "奇幻",
    categorySlug: "fantasy",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20dark%20fantasy%20manhwa%20cover%2C%20mysterious%20demon%20man%20with%20dark%20wings%2C%20gothic%20atmosphere%2C%20deep%20red%20and%20black%20color%20scheme%2C%20clean%20dark%20minimal%20background%2C%20dramatic%20fantasy%20illustration%20style&width=800&height=1120&seq=comic-cover-04&orientation=portrait",
    rating: 9.3,
    views: "720万",
    status: "连载中",
    latestChapter: "第156话",
    updateDate: "2026-07-05",
    description: "为了拯救家人，少女与恶魔签订了危险的契约。黑暗中的救赎、禁断的爱恋，当契约到期之时，她将何去何从？",
    tags: ["奇幻", "暗黑", "恋爱"],
    chapters: [
      { num: 156, title: "契约的尽头", date: "2026-07-05" },
      { num: 155, title: "恶魔的真面目", date: "2026-07-04" },
      { num: 154, title: "最后的愿望", date: "2026-07-03" }
    ]
  },
  {
    id: 5,
    title: "校草别跑",
    author: "张美妍",
    category: "校园",
    categorySlug: "campus",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20school%20romance%20manhwa%20cover%2C%20handsome%20school%20boy%20and%20cute%20girl%20in%20school%20uniform%2C%20cherry%20blossom%20background%2C%20soft%20pink%20and%20blue%20color%20palette%2C%20youthful%20and%20sweet%20atmosphere%2C%20clean%20illustration%20style&width=800&height=1120&seq=comic-cover-05&orientation=portrait",
    rating: 9.4,
    views: "890万",
    status: "连载中",
    latestChapter: "第178话",
    updateDate: "2026-07-06",
    description: "转学生女孩意外住进了校草的家！同一屋檐下，青春萌动的心跳日常。校园里的甜蜜与误会，谱写最纯真的恋爱篇章。",
    tags: ["校园", "恋爱", "青春"],
    chapters: [
      { num: 178, title: "毕业前夕", date: "2026-07-06" },
      { num: 177, title: "说不出口的话", date: "2026-07-05" }
    ]
  },
  {
    id: 6,
    title: "武林至尊",
    author: "赵泰浩",
    category: "武侠",
    categorySlug: "martial",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20cover%2C%20powerful%20warrior%20in%20traditional%20hanbok%2C%20dramatic%20fighting%20pose%2C%20traditional%20Korean%20landscape%20background%2C%20earthy%20brown%20and%20gold%20tones%2C%20epic%20oriental%20illustration%20style&width=800&height=1120&seq=comic-cover-06&orientation=portrait",
    rating: 9.6,
    views: "1150万",
    status: "连载中",
    latestChapter: "第234话",
    updateDate: "2026-07-07",
    description: "江湖风云再起，少年手握绝世武功秘籍踏上武林至尊之路。快意恩仇、侠骨柔情，燃爆你的武侠之魂！",
    tags: ["武侠", "热血", "历史"],
    chapters: [
      { num: 234, title: "天下第一", date: "2026-07-07" },
      { num: 233, title: "终极奥义", date: "2026-07-06" }
    ]
  },
  {
    id: 7,
    title: "星光下的约定",
    author: "韩素希",
    category: "恋爱",
    categorySlug: "romance",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20romance%20drama%20manhwa%20cover%2C%20couple%20under%20starlit%20night%20sky%2C%20romantic%20and%20dreamy%20atmosphere%2C%20soft%20purple%20and%20navy%20color%20scheme%2C%20clean%20illustration%20with%20stars%2C%20emotional%20love%20story%20cover&width=800&height=1120&seq=comic-cover-07&orientation=portrait",
    rating: 9.2,
    views: "450万",
    status: "连载中",
    latestChapter: "第89话",
    updateDate: "2026-07-05",
    description: "天文台实习生与星空摄影师的浪漫邂逅。在每个星光灿烂的夜晚，两颗心慢慢靠近。",
    tags: ["恋爱", "治愈", "都市"],
    chapters: [
      { num: 89, title: "星空的尽头", date: "2026-07-05" },
      { num: 88, title: "你的星座", date: "2026-07-04" }
    ]
  },
  {
    id: 8,
    title: "重生之商业帝国",
    author: "孙泰英",
    category: "都市",
    categorySlug: "urban",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20business%20drama%20manhwa%20cover%2C%20confident%20businessman%20in%20modern%20suit%2C%20city%20skyline%20background%2C%20sophisticated%20gray%20and%20navy%20color%20scheme%2C%20clean%20professional%20illustration%20style%2C%20modern%20urban%20atmosphere&width=800&height=1120&seq=comic-cover-08&orientation=portrait",
    rating: 9.5,
    views: "670万",
    status: "连载中",
    latestChapter: "第145话",
    updateDate: "2026-07-06",
    description: "商业鬼才重生回到十年前，凭借前世记忆创造属于自己的商业帝国。商战风云与情感纠葛，步步惊心。",
    tags: ["都市", "重生", "商战"],
    chapters: [
      { num: 145, title: "帝国的崛起", date: "2026-07-06" },
      { num: 144, title: "关键收购", date: "2026-07-05" }
    ]
  },
  {
    id: 9,
    title: "妖狐传说",
    author: "柳真雅",
    category: "奇幻",
    categorySlug: "fantasy",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20supernatural%20fantasy%20manhwa%20cover%2C%20beautiful%20nine-tailed%20fox%20spirit%20woman%2C%20mystical%20forest%20setting%2C%20ethereal%20white%20and%20silver%20color%20palette%2C%20enchanting%20and%20mysterious%20atmosphere%2C%20clean%20oriental%20fantasy%20illustration&width=800&height=1120&seq=comic-cover-09&orientation=portrait",
    rating: 9.4,
    views: "830万",
    status: "连载中",
    latestChapter: "第167话",
    updateDate: "2026-07-07",
    description: "九尾妖狐化为人形，游走于人世间寻找千年前的约定。人妖殊途，情缘未了，一段跨越千年的奇幻爱恋。",
    tags: ["奇幻", "古风", "恋爱"],
    chapters: [
      { num: 167, title: "千年之约", date: "2026-07-07" },
      { num: 166, title: "妖狐真身", date: "2026-07-06" }
    ]
  },
  {
    id: 10,
    title: "篮球风云",
    author: "权民秀",
    category: "运动",
    categorySlug: "sports",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20sports%20manhwa%20cover%2C%20basketball%20player%20in%20dynamic%20action%20dunking%20pose%2C%20sports%20arena%20background%2C%20energetic%20orange%20and%20white%20color%20scheme%2C%20clean%20sports%20illustration%20style%2C%20competitive%20atmosphere&width=800&height=1120&seq=comic-cover-10&orientation=portrait",
    rating: 9.1,
    views: "560万",
    status: "连载中",
    latestChapter: "第134话",
    updateDate: "2026-07-04",
    description: "高中篮球少年追逐全国大赛梦想，汗水与热血交织的青春运动物语。",
    tags: ["运动", "热血", "校园"],
    chapters: [
      { num: 134, title: "全国大赛开幕", date: "2026-07-04" },
      { num: 133, title: "最后的特训", date: "2026-07-03" }
    ]
  },
  {
    id: 11,
    title: "鬼医圣手",
    author: "郑秀妍",
    category: "悬疑",
    categorySlug: "horror",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20mystery%20thriller%20manhwa%20cover%2C%20mysterious%20doctor%20in%20dark%20hospital%20corridor%2C%20eerie%20atmosphere%2C%20deep%20blue%20and%20gray%20tones%2C%20suspenseful%20mood%2C%20clean%20minimal%20background&width=800&height=1120&seq=comic-cover-11&orientation=portrait",
    rating: 9.0,
    views: "380万",
    status: "连载中",
    latestChapter: "第98话",
    updateDate: "2026-07-03",
    description: "天才医生拥有看见死者记忆的特殊能力，利用这份诅咒般的天赋，破解一桩桩离奇死亡案件。",
    tags: ["悬疑", "医疗", "超能力"],
    chapters: [
      { num: 98, title: "真相", date: "2026-07-03" },
      { num: 97, title: "最后一案", date: "2026-07-02" }
    ]
  },
  {
    id: 12,
    title: "爆笑江湖",
    author: "吴在雄",
    category: "搞笑",
    categorySlug: "comedy",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20cover%2C%20funny%20martial%20arts%20characters%20in%20exaggerated%20poses%2C%20bright%20yellow%20and%20orange%20colors%2C%20humorous%20cartoon%20style%2C%20clean%20white%20background%2C%20playful%20atmosphere&width=800&height=1120&seq=comic-cover-12&orientation=portrait",
    rating: 9.3,
    views: "620万",
    status: "连载中",
    latestChapter: "第112话",
    updateDate: "2026-07-05",
    description: "一群不靠谱的江湖人士的搞笑日常，让你笑到停不下来！史上最无厘头武林群侠传。",
    tags: ["搞笑", "武侠", "日常"],
    chapters: [
      { num: 112, title: "武林大会闹剧", date: "2026-07-05" },
      { num: 111, title: "假掌门人", date: "2026-07-04" }
    ]
  }
];

export const categoryNames: Record<string, string> = {
  romance: "恋爱",
  fantasy: "奇幻",
  campus: "校园",
  urban: "都市",
  martial: "武侠",
  sports: "运动",
  horror: "悬疑",
  comedy: "搞笑"
};

export const faqs = [
  {
    question: "韩漫屋的漫画是免费的吗？",
    answer: "是的，韩漫屋上的所有漫画均免费提供在线阅读。我们致力于为广大读者提供免费正版的韩国漫画资源，无需付费即可享受高品质的阅读体验。"
  },
  {
    question: "韩漫屋支持手机阅读吗？",
    answer: "支持！韩漫屋采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您使用什么设备，都能获得流畅舒适的阅读体验。"
  },
  {
    question: "漫画更新频率如何？",
    answer: "我们每天更新200部以上漫画，热门作品通常每日更新一章。关注我们，不错过任何精彩内容！"
  },
  {
    question: "需要注册才能阅读吗？",
    answer: "大部分漫画无需注册即可直接阅读。注册成为会员后，可以收藏喜欢的漫画、订阅更新提醒，享受更多个性化服务。"
  },
  {
    question: "如何联系我们？",
    answer: "您可以通过邮箱 hello@xv8g8.cn 与我们取得联系，我们的客服团队会在24小时内回复您的问题。"
  }
];